import { ReactNode } from 'react';

import { Divider, Skeleton, Stack, tokens } from '@cast/design-system';

import { WidgetLayout } from '../../_components/ui/WidgetLayout';

export type ChartWithRightLegendCardArgs = {
  testId?: string;
  title?: ReactNode;
  headerEndContent?: ReactNode;
  leftHeader?: ReactNode;
  rightHeader?: ReactNode;
  chart: ReactNode;
  legend: ReactNode;
  isListLoading?: boolean;
  listSkeletonCount?: number;
};

const MARKER_SIZE = 8;
const LEGEND_WIDTH = 300;

const RightLegendListSkeleton = ({ count }: { count: number }) => (
  <Stack flex={1} overflow="hidden">
    {Array.from({ length: count }).map((_, index) => (
      <Stack
        key={index}
        direction="row"
        alignItems="center"
        gap={6}
        py={6}
        px={4}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            width: MARKER_SIZE,
            height: MARKER_SIZE,
            minWidth: MARKER_SIZE,
            minHeight: MARKER_SIZE,
            borderRadius: tokens.theme.radius.xs,
          }}
        />
        <Skeleton variant="text" sx={{ flex: 1 }} />
        <Skeleton variant="text" width={40} />
      </Stack>
    ))}
  </Stack>
);

export const ChartWithRightLegendCard = ({
  testId,
  title,
  headerEndContent,
  leftHeader,
  rightHeader,
  chart,
  legend,
  isListLoading,
  listSkeletonCount = 5,
}: ChartWithRightLegendCardArgs) => {
  return (
    <WidgetLayout
      testId={testId}
      title={title}
      headerEndContent={headerEndContent}
      padding={false}
      sx={{ height: '100%' }}
    >
      <Stack direction="row" height="100%">
        <Stack flex={1} pl={16} pr={16} pb={16} overflow="hidden">
          {leftHeader && (
            <Stack direction="row" alignItems="center" py={12}>
              {leftHeader}
            </Stack>
          )}
          {chart}
        </Stack>
        <Divider orientation="vertical" flexItem />
        <Stack
          data-testid="right-legend-section"
          pl={12}
          pr={16}
          pb={16}
          overflow="hidden"
          sx={{ width: LEGEND_WIDTH, flexShrink: 0 }}
        >
          {rightHeader && (
            <Stack direction="row" alignItems="center" py={12}>
              {rightHeader}
            </Stack>
          )}
          {isListLoading ? (
            <RightLegendListSkeleton count={listSkeletonCount} />
          ) : (
            legend
          )}
        </Stack>
      </Stack>
    </WidgetLayout>
  );
};
